import { gql, type TypedDocumentNode } from "@apollo/client";
import { type GQL } from "@binale-tech/shared";

export const bankingTransactionsContactSuggestions: TypedDocumentNode<
    Pick<GQL.IQuery, "bankingTransactionsContactSuggestions">,
    GQL.IQueryBankingTransactionsContactSuggestionsArgs
> = gql`
    query bankingTransactionsContactSuggestions($companyId: ID!, $transactionIds: [ID!]) {
        bankingTransactionsContactSuggestions(companyId: $companyId, transactionIds: $transactionIds) {
            vatId
            countryCode
            vatNumber
            legalName
            legalAddress
            type
            IBANs
            transactionIds
        }
    }
`;

export const accountReconciliationAccounts: TypedDocumentNode<
    Pick<GQL.IQuery, "accountReconciliationAccounts">,
    GQL.IQueryAccountReconciliationAccountsArgs
> = gql`
    query accountReconciliationAccounts($companyId: ID!, $year: Int!) {
        accountReconciliationAccounts(companyId: $companyId, year: $year) {
            konto
            kind
            openCount
        }
    }
`;

export const accountReconciliationPlan: TypedDocumentNode<
    Pick<GQL.IQuery, "accountReconciliationPlan">,
    GQL.IQueryAccountReconciliationPlanArgs
> = gql`
    query accountReconciliationPlan(
        $companyId: ID!
        $konto: String!
        $mode: ReconciliationMode!
        $key: ReconciliationKey
    ) {
        accountReconciliationPlan(companyId: $companyId, konto: $konto, mode: $mode, key: $key) {
            groups {
                groupId
                sourceKey
                representationKeys
                amounts {
                    recordKey
                    amount
                }
                openAmount
            }
            skipped {
                groupId
                reason
                difference
            }
        }
    }
`;
